angular.module('nv.HelpDeskModule', ['nv.HelpDeskModule.controllers']);
